module.exports = __webpack_public_path__ + "27cee0916cfc91859fc6eae506f361a6.MP3";